import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll position to the top whenever the route path changes (so
// navigating from the footer to a legal page lands at the top), or scrolls
// to the matching section when the URL carries a hash (e.g. nav links on
// other pages pointing back to "/#trails").
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // wait a tick so the target route has rendered before we look for the element
            const id = hash.replace('#', '');
            requestAnimationFrame(() => {
                document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
            });
            return;
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
